export default {
  inject: ['load'],
  data() {
    return {
      allAbdomenExaminationsForOther: [],
      abdomenExamination: null,
    };
  },
  methods: {
    getListOfAbdomenExaminationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllAbdomenExaminations').then(() => {
        if (this.$store.state.abdomenExaminationModule.successFlag) {
          this.allAbdomenExaminationsForOther =
            this.$store.state.abdomenExaminationModule.allAbdomenExaminations;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.abdomenExaminationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfAbdomenExaminationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAbdomenExaminationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAbdomenExamination', id).then(() => {
        if (this.$store.state.abdomenExaminationModule.successFlag) {
          this.abdomenExamination = this.$store.state.abdomenExaminationModule.abdomenExamination;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.abdomenExaminationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAbdomenExaminationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.abdomenExaminationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
